module.exports = __webpack_public_path__ + "static/media/adept7-logo.f3d6741b.svg";